import { type VariantProps } from 'tailwind-variants';
import ContentfulImage from '../Contentful/components/ContentfulImage';
import { cn } from '@ngg/storefront-utils';
import { Heading } from '../Heading/Heading';
import Link from '../Link/Link';
import { PageFragment, SplashFragment } from '@business/gql/graphql';
import navSplashVariants from './NavSplash.styles';
import Paragraph from '../Paragraph/Paragraph';

type SplashProps = SplashFragment &
  VariantProps<typeof navSplashVariants> & {
    className?: string;
    locale?: string;
    priority?: boolean;
  };

function SplashLink({
  href,
  className,
  locale,
  children,
}: {
  href: string | null | undefined;
  className: string;
  locale?: string;
  children: React.ReactNode;
}) {
  if (href) {
    return (
      <Link className={cn('group', className)} href={href} locale={locale}>
        {children}
      </Link>
    );
  }

  return <article className={className} />;
}

export default function NavSplash({
  className,
  locale,
  desktopImage,
  mobileImage,
  header,
  subheading,
  href,
  backdrop,
}: SplashProps) {
  const {
    base: baseSlot,
    heading: headingSlot,
    subheading: subheadingSlot,
    content: contentSlot,
    image: imageSlot,
  } = navSplashVariants({
    backdrop,
  });

  return (
    <div className="relative flex flex-col justify-start gap-2">
      <SplashLink
        href={(href as PageFragment)?.slug}
        locale={locale}
        className={baseSlot({ className })}>
        <ContentfulImage
          className={cn(imageSlot())}
          desktopImage={desktopImage}
          mobileImage={mobileImage}
          priority={false}
          sizes="(max-width: 1024px) 90vw, 360px"
        />
      </SplashLink>
      <Link href={(href as PageFragment)?.slug || ''} locale={locale}>
        <div className={contentSlot()}>
          <Heading size={3} className={headingSlot()}>
            {header}
          </Heading>
          {subheading && (
            <Paragraph className={subheadingSlot()}>{subheading}</Paragraph>
          )}
        </div>
      </Link>
    </div>
  );
}
